var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
let AppContainer = class AppContainer extends LitElement {
    static { this.styles = css `
    :host {
      display: block;
      width: 100%;
    }

    .content {
      padding: 1.5rem;
    }
  `; }
    render() {
        return html `
      <div class="content">
        <remove-replace-me></remove-replace-me>
      </div>
    `;
    }
};
AppContainer = __decorate([
    customElement('app-container')
], AppContainer);
export { AppContainer };
//# sourceMappingURL=app-container.js.map